import styled from 'styled-components';
import { Typography } from '@material-ui/core';

export const Title = styled(Typography)`
  text-align: center;
  color: ${({ theme }) => theme.palette.primary.main};
  font-weight: bold;
  padding: 20px 0 30px;
  font-size: 3.75rem;
`;
